// Signed-out visitors to the dashboard's own pages (the scanner home,
// #/reports, #/queue, #/billing) sign in on the marketing site, which owns
// the front door. The dashboard keeps no signed-out start page of its own.
// The public routes (claim landing, anonymous #/scan/:id, #/sales/:id,
// #/payment-success, the post-payment screen) never come through here.

export const SIGN_IN_BOUNCE_KEY = 'privisy_sign_in_bounce';

// If the marketing site signs the visitor in but this app still reads no
// session (a cookie-domain mismatch, a blocked third-party cookie), the two
// would bounce the visitor back and forth forever. One bounce per window,
// then the dashboard shows its own sign-in instead.
const BOUNCE_WINDOW_MS = 60_000;

export function marketingSignInUrl(returnTo: string): string {
  const marketingUrl = (process.env.REACT_APP_MARKETING_URL || 'https://getprivisy.com').replace(/\/$/, '');
  return `${marketingUrl}/sign-in?redirect_url=${encodeURIComponent(returnTo)}`;
}

/**
 * True when this visitor may be sent to the marketing sign-in now, and
 * records the bounce. False when they were sent there inside the window and
 * came back still signed out.
 */
export function claimSignInBounce(storage: Storage, now: number): boolean {
  try {
    const last = Number(storage.getItem(SIGN_IN_BOUNCE_KEY));
    if (Number.isFinite(last) && last > 0 && now - last <= BOUNCE_WINDOW_MS) return false;
    storage.setItem(SIGN_IN_BOUNCE_KEY, String(now));
  } catch {
    // No storage (private mode, blocked site data): bounce anyway. The loop
    // guard is a safety net, not a precondition.
  }
  return true;
}

/** A property of an exported object, so tests can spy on it under @swc/jest. */
export const navigation = {
  replace(url: string): void {
    window.location.replace(url);
  },
};
